module.exports = __webpack_public_path__ + "static/media/caret-square-left.93de49cb.svg";